(function () {
  function updateLoadMoreProgress(collectionPage) {
    var currentGrid = collectionPage.querySelector('#productsGrid');
    var loadMoreSection = collectionPage.querySelector('#loadMoreSection');
    if (!currentGrid || !loadMoreSection) return;
    var shown = currentGrid.querySelectorAll('[data-product-card]').length;
    var total = parseInt(loadMoreSection.dataset.totalProducts, 10);
    if (!Number.isFinite(total) || total < shown) total = shown;

    var label = loadMoreSection.querySelector('#loadMoreLabel');
    var template = loadMoreSection.dataset.showingTemplate || '';
    if (label && template) {
      label.textContent = template.replace('__COUNT__', String(Math.min(shown, total)));
    }

    var fill = loadMoreSection.querySelector('.load-more-fill');
    if (fill && total > 0) {
      fill.style.width = Math.min(100, Math.round((shown / total) * 100)) + '%';
    }
  }

  function disconnectInfiniteScroll(collectionPage) {
    if (!collectionPage || !collectionPage._axiomInfiniteScrollObserver) return;
    collectionPage._axiomInfiniteScrollObserver.disconnect();
    collectionPage._axiomInfiniteScrollObserver = null;
  }

  function syncInfiniteScroll(collectionPage) {
    disconnectInfiniteScroll(collectionPage);

    var loadMoreSection = collectionPage.querySelector('[data-collection-load-more]');
    if (!loadMoreSection) return;

    var trigger = loadMoreSection.querySelector('[data-load-more]');
    if (trigger) {
      trigger.removeAttribute('aria-hidden');
      trigger.removeAttribute('tabindex');
    }

    if (
      loadMoreSection.dataset.paginationMode !== 'infinite_scroll' ||
      !trigger ||
      !('IntersectionObserver' in window)
    ) {
      return;
    }

    trigger.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('tabindex', '-1');

    collectionPage._axiomInfiniteScrollObserver = new IntersectionObserver(function (entries) {
      var shouldLoad = entries.some(function (entry) {
        return entry.isIntersecting;
      });
      if (!shouldLoad) return;

      var currentTrigger = loadMoreSection.querySelector('[data-load-more]');
      if (currentTrigger && currentTrigger.getAttribute('aria-disabled') !== 'true') currentTrigger.click();
    }, { rootMargin: '0px 0px 320px 0px', threshold: 0 });

    collectionPage._axiomInfiniteScrollObserver.observe(loadMoreSection);
  }

  function appendLoadedProducts(collectionPage, nextDocument) {
    var currentGrid = collectionPage.querySelector('#productsGrid');
    var nextGrid = nextDocument.getElementById('productsGrid');
    if (!currentGrid || !nextGrid) return null;

    var appendedCards = Array.prototype.slice.call(nextGrid.children);
    appendedCards.forEach(function (card) {
      card.classList.add('is-filter-entering');
      currentGrid.appendChild(card);
    });
    if (window.Axiom && typeof window.Axiom.revealElements === 'function') {
      window.Axiom.revealElements(currentGrid, {
        trigger: 'manual',
        reset: true,
        selector: '[data-product-card].is-filter-entering',
        stagger: 58,
      });
    }
    appendedCards.forEach(function (card) {
      card.classList.remove('is-filter-entering');
    });
    if (window.AxiomProductCard && typeof window.AxiomProductCard.initialize === 'function') {
      appendedCards.forEach(function (card) {
        window.AxiomProductCard.initialize(card);
      });
    }

    var loadMoreSection = collectionPage.querySelector('#loadMoreSection');
    var nextLoadMoreSection = nextDocument.getElementById('loadMoreSection');
    if (loadMoreSection && nextLoadMoreSection) {
      loadMoreSection.innerHTML = nextLoadMoreSection.innerHTML;
      if (nextLoadMoreSection.dataset.paginationMode) {
        loadMoreSection.dataset.paginationMode = nextLoadMoreSection.dataset.paginationMode;
      }
      if (nextLoadMoreSection.dataset.totalProducts) {
        loadMoreSection.dataset.totalProducts = nextLoadMoreSection.dataset.totalProducts;
      }
      if (nextLoadMoreSection.dataset.showingTemplate) {
        loadMoreSection.dataset.showingTemplate = nextLoadMoreSection.dataset.showingTemplate;
      }
      updateLoadMoreProgress(collectionPage);
    } else if (loadMoreSection) {
      loadMoreSection.remove();
    }
    return appendedCards;
  }

  function focusFirstAppendedProduct(appendedCards) {
    if (!appendedCards || !appendedCards.length) return;
    var firstFocusable = appendedCards[0].querySelector(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (firstFocusable && typeof firstFocusable.focus === 'function') firstFocusable.focus();
  }

  function bindLoadMore(collectionPage) {
    var collectionMain = collectionPage.querySelector('.collection-main');
    if (!collectionMain) return;
    if (collectionMain.dataset.loadMoreBound === 'true') {
      syncInfiniteScroll(collectionPage);
      return;
    }
    collectionMain.dataset.loadMoreBound = 'true';
    var loadMoreActive = false;

    collectionMain.addEventListener('click', function (event) {
      var trigger = event.target && event.target.closest ? event.target.closest('[data-load-more]') : null;
      if (!trigger || !collectionMain.contains(trigger)) return;
      event.preventDefault();

      var nextUrl = trigger.getAttribute('href');
      if (loadMoreActive || !nextUrl) return;
      var shouldFocusAppendedProduct = event.detail === 0 && document.activeElement === trigger;
      loadMoreActive = true;
      trigger.setAttribute('aria-disabled', 'true');
      trigger.classList.add('loading');
      var loadMoreSection = trigger.closest('[data-collection-load-more]');
      if (loadMoreSection) {
        loadMoreSection.setAttribute('aria-busy', 'true');
        var loadingStatus = loadMoreSection.querySelector('[data-load-more-status]');
        if (loadingStatus) {
          loadingStatus.textContent = '';
          window.requestAnimationFrame(function () {
            if (loadingStatus.isConnected) loadingStatus.textContent = loadMoreSection.dataset.loadingText || '';
          });
        }
      }

      // Only this section's markup is needed: parsing the whole next page
      // blocks the main thread long enough to stall the scroll that asked for it.
      var sectionId = collectionPage.dataset.sectionId;
      var fetchUrl = sectionId
        ? nextUrl + (nextUrl.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId)
        : nextUrl;

      fetch(fetchUrl, { headers: { 'Accept': 'text/html' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Load more request failed');
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var nextDocument = parser.parseFromString(html, 'text/html');
          var appendedCards = appendLoadedProducts(collectionPage, nextDocument);
          if (!appendedCards) {
            window.location.assign(nextUrl);
            return;
          }
          if (shouldFocusAppendedProduct) focusFirstAppendedProduct(appendedCards);
        })
        .catch(function () {
          window.location.assign(nextUrl);
        })
        .finally(function () {
          loadMoreActive = false;
          if (loadMoreSection && loadMoreSection.isConnected) {
            loadMoreSection.setAttribute('aria-busy', 'false');
            var currentLoadingStatus = loadMoreSection.querySelector('[data-load-more-status]');
            if (currentLoadingStatus) currentLoadingStatus.textContent = '';
          }
          if (trigger.isConnected) {
            trigger.removeAttribute('aria-disabled');
            trigger.classList.remove('loading');
          }
          syncInfiniteScroll(collectionPage);
        });
    });

    syncInfiniteScroll(collectionPage);
  }

  function getGridViewStorageKey(collectionPage, target) {
    var sectionId = collectionPage.dataset.sectionId || 'collection';
    var optionKey = target === 'mobile' ? 'gridViewOptionsMobile' : 'gridViewOptionsDesktop';
    var options = collectionPage.dataset[optionKey] || '';
    return 'axiom:collection-grid:' + sectionId + ':' + target + ':' + options;
  }

  function applyGridView(collectionPage, target, columns, persist) {
    var options = Array.prototype.slice.call(
      collectionPage.querySelectorAll('[data-grid-target="' + target + '"][data-grid-columns]')
    );
    var selectedOption = null;
    options.forEach(function (option) {
      if (option.dataset.gridColumns === String(columns)) selectedOption = option;
    });
    if (!selectedOption) return;
    var selectionChanged = !selectedOption.classList.contains('is-active');

    var property = target === 'mobile' ? '--collection-columns-mobile' : '--collection-columns-desktop';
    var profileIndex = selectedOption.dataset.gridProfileIndex || String(options.indexOf(selectedOption) + 1);
    var profilePrefix = 'data-grid-profile-' + profileIndex + '-';
    var profileState = {
      title: collectionPage.getAttribute(profilePrefix + 'show-title') !== 'false',
      price: collectionPage.getAttribute(profilePrefix + 'show-price') !== 'false',
      vendor: collectionPage.getAttribute(profilePrefix + 'show-vendor') === 'true',
      variants: collectionPage.getAttribute(profilePrefix + 'show-variants') !== 'false',
      variantStyle: collectionPage.getAttribute(profilePrefix + 'variant-style') || 'hover_reveal',
      variantOverlap: collectionPage.getAttribute(profilePrefix + 'variant-overlap') !== 'false',
      badges: collectionPage.getAttribute(profilePrefix + 'show-badges') !== 'false',
      quickView: collectionPage.getAttribute(profilePrefix + 'show-quick-view') !== 'false',
      alignment: collectionPage.getAttribute(profilePrefix + 'content-alignment') || 'inherit',
      gap: collectionPage.getAttribute(profilePrefix + 'gap-' + target) || (target === 'mobile' ? '12' : '24'),
    };
    var statePrefix = 'data-grid-' + target + '-';

    collectionPage.style.setProperty(property, String(columns));
    collectionPage.style.setProperty('--collection-grid-gap-' + target, profileState.gap + 'px');
    collectionPage.setAttribute('data-grid-profile-' + target, profileIndex);
    collectionPage.setAttribute(statePrefix + 'show-title', String(profileState.title));
    collectionPage.setAttribute(statePrefix + 'show-price', String(profileState.price));
    collectionPage.setAttribute(statePrefix + 'show-vendor', String(profileState.vendor));
    collectionPage.setAttribute(statePrefix + 'show-variants', String(profileState.variants));
    collectionPage.setAttribute(statePrefix + 'variant-style', profileState.variantStyle);
    collectionPage.setAttribute(statePrefix + 'variant-overlap', String(profileState.variantOverlap));
    collectionPage.setAttribute(statePrefix + 'show-badges', String(profileState.badges));
    collectionPage.setAttribute(statePrefix + 'show-quick-view', String(profileState.quickView));
    collectionPage.setAttribute(
      statePrefix + 'show-meta',
      String(profileState.title || profileState.price || profileState.vendor || profileState.variants)
    );
    collectionPage.setAttribute(statePrefix + 'show-meta-slot', String(profileState.price || profileState.variants));
    collectionPage.setAttribute(statePrefix + 'meta-swap', String(profileState.price && profileState.variants));
    collectionPage.setAttribute(statePrefix + 'content-alignment', profileState.alignment);
    options.forEach(function (option) {
      var isSelected = option === selectedOption;
      option.classList.toggle('is-active', isSelected);
      option.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    if (!persist) return;
    if (
      selectionChanged &&
      collectionPage.dataset.animateGridViewChange === 'true' &&
      window.Axiom &&
      typeof window.Axiom.revealElements === 'function'
    ) {
      var productsGrid = collectionPage.querySelector('#productsGrid');
      if (productsGrid) {
        window.Axiom.revealElements(productsGrid, {
          trigger: 'manual',
          reset: true,
          selector: '[data-product-card]',
          stagger: 40,
        });
      }
    }
    try {
      window.localStorage.setItem(getGridViewStorageKey(collectionPage, target), String(columns));
    } catch (error) {
      // The selected layout still applies for this page when storage is unavailable.
    }
  }

  function bindGridView(collectionPage) {
    ['desktop', 'mobile'].forEach(function (target) {
      var defaultKey = target === 'mobile' ? 'gridColumnsDefaultMobile' : 'gridColumnsDefaultDesktop';
      var initialColumns = collectionPage.dataset[defaultKey] || '';
      try {
        initialColumns = window.localStorage.getItem(getGridViewStorageKey(collectionPage, target)) || initialColumns;
      } catch (error) {
        // Use the merchant-configured default when storage is unavailable.
      }
      applyGridView(collectionPage, target, initialColumns, false);
    });

    if (collectionPage.dataset.gridViewBound === 'true') return;
    collectionPage.dataset.gridViewBound = 'true';
    collectionPage.addEventListener('click', function (event) {
      var option = event.target && event.target.closest ? event.target.closest('[data-grid-columns]') : null;
      if (!option || !collectionPage.contains(option)) return;
      applyGridView(collectionPage, option.dataset.gridTarget || 'desktop', option.dataset.gridColumns, true);
    });
  }

  function initAxiomCollection(root) {
    var scope = root && root.querySelector ? root : document;
    var collectionPage = scope.querySelector('[data-collection-page]') || document.querySelector('[data-collection-page]');
    if (!collectionPage) return;

    if (window.AxiomFilterRenderer) {
      window.AxiomFilterRenderer.init({
        scope: scope,
        rootSelector: '[data-collection-page]',
        mainSelector: '.collection-main',
        activeLinkSelector: '.active-filters a[href], .drawer-clear[href], .empty-state a[href]',
        afterRender: initAxiomCollection
      });
    }

    bindLoadMore(collectionPage);
    bindGridView(collectionPage);
    updateLoadMoreProgress(collectionPage);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAxiomCollection(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAxiomCollection(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var collectionPage = event.target.querySelector('[data-collection-page]');
    disconnectInfiniteScroll(collectionPage);
  });
})();
